/* eslint-disable no-throw-literal */
import apiClient from './apiClient.js';

export const getAppSchedulerJobsByDomainId = (id) => apiClient.get(`/scheduler-jobs/domain/${id}`);
export const updateAppSchedulerJobsAttr = (id, data) => apiClient.put(`/scheduler-jobs/${id}`, data);
export const executeAppSchedulerJobsByName = (name) => apiClient.post(`/scheduler-jobs/${name}/execute`);
export const deleteAppSchedulerById = (id) => apiClient.delete(`/scheduler-jobs/${id}`);
export const toggleAppSchedulerJobState = (name, data) => apiClient.put(`/scheduler-jobs/${name}/state`, data);

export const createAppSchedulerJob = async (data) => {
  try {
    const response = await apiClient.post('/scheduler-jobs', data);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 409) {
          throw { type: 'duplicate', message: error.response.data?.error || 'El usuario ya existe.' };
      }
      throw { type: 'general', message: error.response.data?.error || 'Ha ocurrido un error, por favor intente nuevamente.' };
    }
    throw { type: 'general', message: 'Error de conexión, por favor intente nuevamente.' };
  }
};
